export const RESEARCH_STORE_NAME = 'research';
export const RESEARCH_HEADER_MAPPING_NAME = 'researchBlock';
